import Vue from 'vue'


Vue.filter('splitted', (text, substring) => {
  return text.split(substring)[0] || text
})

